<div class="ratings-location-display">
  <div [class]="'country-flag fi fi-' + countryCode()"></div>
  <div class="display-text">
    @for (item of locationDisplayText; track item) {
      <span>{{ item }}</span>
    }
  </div>
</div>